import { render, staticRenderFns } from "./Requisicoes.vue?vue&type=template&id=2e9b9cf9&"
import script from "./Requisicoes.vue?vue&type=script&lang=js&"
export * from "./Requisicoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports